import { Constants } from "../../../contants";
import {
  INITIATE_VIEW_ANNOUNCEMENT_CYCLE_DATA,
  SET_VIEW_ANNOUNCEMENT_CYCLE_DATA,
  SET_VIEW_ANNOUNCEMENT_CYCLE_FAIL,
} from "../../actionTypes/dashboard";

const INITIAL_STATE = {
  data: [],
  isLoading: false,
  error: null,
  paginationInfo: {
    currentPage: 0,
    totalPages: 1,
    totalElements: 0,
    pageSize: Constants.DEFAULT_PAGE_SIZE,
  },
};

// eslint-disable-next-line default-param-last
const reducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case INITIATE_VIEW_ANNOUNCEMENT_CYCLE_DATA:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case SET_VIEW_ANNOUNCEMENT_CYCLE_DATA:
      return {
        ...state,
        data: payload,
        paginationInfo: payload?.paginationInfo,
        isLoading: false,
      };
    case SET_VIEW_ANNOUNCEMENT_CYCLE_FAIL:
      return {
        ...state,
        data: [],
        isLoading: false,
        error: payload,
      };

    default:
      return {
        ...state,
      };
  }
};

export default reducer;
